export default "__VITE_ASSET__0tr8VINn__"